let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("pEAei")).then(() => parcelRequire('gI3cQ'));